import { SHOW_NEXT, SHOW_PREVIOUS, SET_ACTIVE_INDEX } from '../../actions/CarouselActions';
import { modulo } from '../../helpers/Math';

export default class CarouselReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 */
	static reduce(state = {}, action) {
		switch (action.type) {
			case SET_ACTIVE_INDEX:
				return {
					...state,
					carouselRaffles: {
						...state.carouselRaffles,
						activeIndex: modulo(action.index, state.carouselRaffles.items.length) // sanity check
					}
				};
			case SHOW_PREVIOUS:
				return {
					...state,
					carouselRaffles: {
						...state.carouselRaffles,
						activeIndex: modulo(state.carouselRaffles.activeIndex - 1, state.carouselRaffles.items.length)
					}
				};
			case SHOW_NEXT:
				return {
					...state,
					carouselRaffles: {
						...state.carouselRaffles,
						activeIndex: modulo(state.carouselRaffles.activeIndex + 1, state.carouselRaffles.items.length)
					}
				};
			default:
				return state;
		}
	}
}



// WEBPACK FOOTER //
// ./reducers/homepage/CarouselReducer.js